<div class="continer-popup-help" >
    <div class="popup" (closePopup)="closePopup.emit()">
        <div class="header-tooltip">
           {{title}}
             <button class="btn-close" (click)="closePopup.emit()"> </button>
        </div>
        <div class="contect" innerHTML=" {{contect}}">
        </div>
       
         <p-button  (click)="closePopup.emit()" label="תודה הבנתי"> </p-button>
    </div>
</div>

